// extracted by mini-css-extract-plugin
export default {"name":"DoctorCard_name__GxTIQ","specialty":"DoctorCard_specialty__d8QOL","medicalCenter":"DoctorCard_medicalCenter__IPaq5"};